/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const AttachmentIcon = React.forwardRef<HTMLDivElement, BaseIconProps>(
  ({size = 16, ...props}, ref) => {
    return (
      <BaseIcon {...props} size={size} ref={ref}>
        <svg
          data-wf-icon="AttachmentIcon"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M11.8536 2.14648L12.0252 2.31806C13.7825 4.07542 13.7825 6.92466 12.0252 8.68202L8.85361 11.8536C7.55378 13.1534 5.44634 13.1534 4.1465 11.8536C2.84667 10.5538 2.84667 8.44631 4.14651 7.14648L7.1465 4.14648C7.89405 3.39894 9.10606 3.39894 9.85361 4.14648C10.6012 4.89403 10.6012 6.10604 9.85361 6.85359L6.85361 9.85359L6.1465 9.14648L9.1465 6.14648C9.50353 5.78946 9.50353 5.21061 9.1465 4.85359C8.78948 4.49657 8.21063 4.49657 7.85361 4.85359L4.85361 7.85359C3.9443 8.7629 3.9443 10.2372 4.85361 11.1465C5.76292 12.0558 7.2372 12.0558 8.1465 11.1465L11.3181 7.97491C12.6849 6.60807 12.6849 4.392 11.3181 3.02516L11.1465 2.85359L11.8536 2.14648Z"
              fill="currentColor"
            />
          </g>
        </svg>
      </BaseIcon>
    );
  }
) as IconComponent;

AttachmentIcon.tags = [
  'paperclip',
  'attach',
  'link',
  'connect',
  'bind',
  'clip',
  'document',
];

AttachmentIcon.category = 'General Icons';

AttachmentIcon.iconSize = 16;
